'use client';

import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useAppState } from '@/state/hooks/app.state.hook';
import { isEnterKey } from '@/lib/utils/keyboard';
import { IconClose } from '@/components/icons/SimpleIcons';
import { useLockBodyScroll } from '@/hooks/useLockBodyScroll';

export const InfoModal: React.FC = () => {
  const { t } = useTranslation();
  const { infoModalUrl, closeInfoModal } = useAppState();
  const [isLoading, setIsLoading] = useState(true);

  useLockBodyScroll(!!infoModalUrl);

  useEffect(() => {
    if (infoModalUrl) {
      setIsLoading(true);
    }
  }, [infoModalUrl]);

  if (!infoModalUrl) return null;

  return (
    <div
      className="fixed inset-0 bg-black/50 z-[10000] flex items-center justify-center p-4 md:p-6 box-border"
      data-testid="info-modal"
    >
      <div className="relative bg-white w-[94%] h-[70%] md:w-[80%] md:h-[80%] md:max-w-[1000px] md:max-h-[800px] p-2 pt-[30px] md:p-6 md:pt-[60px]">
        <IconClose
          className="absolute right-2 top-2.5 md:right-6 md:top-5 text-black text-xl cursor-pointer hover:opacity-70 transition-opacity"
          onClick={closeInfoModal}
          aria-label="Close"
          role="button"
          tabIndex={0}
          onKeyDown={(e: React.KeyboardEvent) => isEnterKey(e) && closeInfoModal()}
        />

        <iframe
          title={t('infoModal.legalInfo')}
          src={infoModalUrl}
          className="w-full h-full border-0"
          onLoad={() => setIsLoading(false)}
        />
      </div>

      {isLoading && (
        <div className="absolute inset-0 flex items-center justify-center">
          <div className="animate-spin rounded-full h-12 w-12 border-4 border-white border-t-transparent" />
        </div>
      )}
    </div>
  );
};
